import React, { Component } from 'react';

export default class RequiredText extends Component {

    render() {

        return <div className={"form__required-text"}><span className={"orange"}>*</span> &mdash; поля, обязательные для заполнения</div>
    }
}